/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Season
 */
export interface Season {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof Season
     */
    readonly $schema?: string;
    /**
     * Season begin date
     * @type {Date}
     * @memberof Season
     */
    beginDate: Date;
    /**
     * Season created at
     * @type {Date}
     * @memberof Season
     */
    createdAt: Date;
    /**
     * Season end date
     * @type {Date}
     * @memberof Season
     */
    endDate: Date;
    /**
     * Season ID
     * @type {number}
     * @memberof Season
     */
    id: number;
    /**
     * Season name
     * @type {string}
     * @memberof Season
     */
    name: string;
    /**
     * Regular season begin date
     * @type {Date}
     * @memberof Season
     */
    regularSeasonBeginDate: Date;
    /**
     * Regular season end date
     * @type {Date}
     * @memberof Season
     */
    regularSeasonEndDate: Date;
    /**
     * Season updated at
     * @type {Date}
     * @memberof Season
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the Season interface.
 */
export function instanceOfSeason(value: object): value is Season {
    if (!('beginDate' in value) || value['beginDate'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('regularSeasonBeginDate' in value) || value['regularSeasonBeginDate'] === undefined) return false;
    if (!('regularSeasonEndDate' in value) || value['regularSeasonEndDate'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SeasonFromJSON(json: any): Season {
    return SeasonFromJSONTyped(json, false);
}

export function SeasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Season {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'beginDate': (new Date(json['begin_date'])),
        'createdAt': (new Date(json['createdAt'])),
        'endDate': (new Date(json['end_date'])),
        'id': json['id'],
        'name': json['name'],
        'regularSeasonBeginDate': (new Date(json['regular_season_begin_date'])),
        'regularSeasonEndDate': (new Date(json['regular_season_end_date'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SeasonToJSON(json: any): Season {
    return SeasonToJSONTyped(json, false);
}

export function SeasonToJSONTyped(value?: Omit<Season, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'begin_date': value['beginDate'].toISOString(),
        'createdAt': value['createdAt'].toISOString(),
        'end_date': value['endDate'].toISOString(),
        'id': value['id'],
        'name': value['name'],
        'regular_season_begin_date': value['regularSeasonBeginDate'].toISOString(),
        'regular_season_end_date': value['regularSeasonEndDate'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

